"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultsQuery = void 0;
const next_1 = require("../../types/next");
exports.getDefaultsQuery = `
  query getDefaults {
    defaults {
      calculations {
        leasing {
          business {
            ...leasing
          }
          private {
            ...leasing
          }
          metadata {
            durationMonths {
              ...dropdown
            }
            interestRate
            mileage {
              ...dropdown
            }
          }
        }
        loan {
          business {
            ...loan
          }
          private {
            ...loan
          }
          metadata {
            durationMonths {
              ...dropdown
            }
            interestRate
          }
        }
      }
    }
  }
  
  ${next_1.leasingInputFragment}
  ${next_1.loanInputFragment}
  ${next_1.dropdownOptionFragment}
`;
//# sourceMappingURL=defaults.js.map